import React from 'react';

import { NavigationReducerDataFilterTags } from '../../../Redux/Reducers/NavigationReducer';
import { CollectionFilter } from '../../Data/CollectionFilter';
import { ISelectedFilter } from '../../Data/SelectedFilter';
import { FilterComponent } from '../Components/Specific/FilterComponent';

type FilterControllerParameters =
{
  filters : CollectionFilter[];
  filterSelection: NavigationReducerDataFilterTags[] | undefined;
  setFilterSelection : (newFilterSelection: NavigationReducerDataFilterTags[]) => void;
};

export function FilterController(
  {
    filters,
    filterSelection, setFilterSelection,
  } : FilterControllerParameters,
) {

  const selectFilterHandler = (filterType : string, filterValue : string) => {
    // Create a copy of current filters

    let filtersSelectedCopy : Array<ISelectedFilter> = [];

    if (filterSelection) {
      filtersSelectedCopy = filterSelection.map((item) => {
        return { type: item.type, value: item.value };
      });
    }

    // Find the current filter type in the current set of options

    const option = filtersSelectedCopy.find(
      (filter) => filter.type === filterType,
    );

    if (option) {
      // We already have an option for this filter type.
      if (filterValue.trim() === '') {
        // Remove the entry
        filtersSelectedCopy = filtersSelectedCopy.filter(
          (filterEntry) => filterEntry.type !== filterType,
        );
      } else {
        // Update the value
        option.value = filterValue;
      }
    } else {
      // We don't have that option in the filter yet.
      // eslint-disable-next-line no-lonely-if
      if (filterValue.trim() === '') {
        // Do nothing
      } else {
        // Create a new item and add it to the array
        filtersSelectedCopy.push({ type: filterType, value: filterValue });
      }
    }
    setFilterSelection(filtersSelectedCopy);
  };

  return (
    filters.length > 0 ? (
      <FilterComponent
        filters={filters}
        filterSelection={filterSelection}
        selectFilterHandler={selectFilterHandler}
      />
    ) : (
      <div />
    )
  );
}
